<template>
    <div class="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4 sm:p-6 lg:p-8">
      <div class="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 class="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-gray-800">Register</h2>
        <form @submit.prevent="login" class="flex flex-col space-y-4">
         <input v-model="user.name"
                 class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green"
                 placeholder="Names"
                 required />
          <input v-model="user.phone"
                 class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green"
                 placeholder="Phone"
                 required />
          <input v-model="user.email"
                 class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green"
                 placeholder="Email"
                 required />

                 <input v-model="user.address"
                 class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green"
                 placeholder="Address"
                 required />
          <input type="password" v-model="user.password"
                 class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green"
                 placeholder="Password"
                 required />
          <div class="relative">
                <input type="password" v-model="user.repeatedPassword"
                    class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green"
                    placeholder="Repeat Password"
                    required />
                 <!-- Conditional rendering of danger icon -->
                <span v-if="user.repeatedPassword && user.repeatedPassword !== user.password"
                  class="absolute right-2 top-1/2 transform -translate-y-1/2 text-red-500">
                  <!-- Danger icon (e.g., an exclamation mark or cross icon) -->&#9888;</span>
           </div>
          <button type="submit"
                  class="bg-green text-white p-2 sm:p-3 rounded-lg hover:bg-green-600 w-full">
            Register
          </button>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions } from 'vuex';
  import { useRouter } from 'vue-router';
  //import VueJwtDecode from 'vue-jwt-decode';
  export default {
    data() {
      return {
        router : useRouter(),
        user: {
          name: '',
          phone : '',
          email : '',
          address : '',
          password: '',
          repeatedPassword : '',
        },
      };
    },
   
    mounted() {
      //this.checkLogin
   },
    methods: {
      ...mapActions('auth', {
        registerClient : 'registerClient'
      }),
      async login() {
        try {
          await this.registerClient(this.user);
          this.router.push('/client');
        } catch (error) {
          console.error('Login failed:', error);
          //alert('Invalid user. Please try again.');
        }
      },
      async checkLogin(){
      }
    },
  };
  </script>
  